import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-home-blog',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './home-blog.component.html',
  styleUrl: './home-blog.component.scss'
})
export class HomeBlogComponent {

  isToggled = false;
	blogs
	imageUrl = getImgeUrl()

	constructor(
	  public themeService: ThemeCustomizerService,
	  private publicService: PublicServiceService
	) {
	  this.themeService.isToggled$.subscribe(isToggled => {
		this.isToggled = isToggled;
	  });
		
	}
  
	toggleTheme() {
	  this.themeService.toggleTheme();
	}
  
	ngOnInit(): void { 
	  this.getData()
	}
  
	getData() {
		this.publicService.getRecordHome(this.publicService.BLOGS_URL).subscribe({
		  next: (res) => {
			this.blogs = res
	
		  },
		  error: (error) => {
			console.error("here goes the Unexpected error:", error);
		  }
		})
	  }

}
